import { createAction, props } from '@ngrx/store';
import { Channel, Message } from "../../../core/models/messaging.models";
import { User } from "../../../core/user/user.types";
import { WebSocketEventData } from "../../../core/models/api.response.model";

export const resetState = createAction('[MESSAGING] RESET_STATE');

export const setUser = createAction('[MESSAGING] SET_USER', props<{
    user: User
}>())

export const insertWebSocketEventData = createAction(
    '[MESSAGING] INSERT_WEB_SOCKET_EVENT_DATA',
    props<{ eventData: WebSocketEventData, topic: string, key: number }>()
);

export const upsertChannels = createAction(
    '[MESSAGING] UPSERT_CHANNELS',
    props<{ channels: Channel[], totalChannelLimit?: number }>()
)

export const setActiveChannel = createAction(
    '[MESSAGING] SET_ACTIVE_CHANNEL',
    props<{
        channelId: string,
        initialChannelMessageId?: string
    }>()
)

export const deleteChannel = createAction(
    '[MESSAGING] DELETE_CHANNEL',
    props<{ channelId: string }>()
)

export const upsertActiveChannelAndMessage = createAction(
    '[MESSAGING] UPSERT_ACTIVE_CHANNEL_AND_MESSAGE',
    props<{ message: Message, channel: Channel }>()
)

export const upsertMessages = createAction(
    '[MESSAGING] UPSERT_MESSAGES',
    props<{ messages: Message[] }>()
)

export const setChannelFilter = createAction(
    '[MESSAGING] SET_CHANNEL_FILTER',
    props<{ key: string, value: any }>()
)

export const setTopicValidationKey = createAction(
    '[MESSAGING] SET_TOPIC_VALIDATION_KEY',
    props<{ topic: string, key: number }>()
)

export const emptyEvent = createAction('[MESSAGING] EMPTY_EVENT')
